module.exports = __webpack_public_path__ + "_/common/src/assets/fonts/materialdesignicons-webfont.eot";